import { cn } from "@/lib/utils";

export interface SectionCardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  eyebrow?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  dense?: boolean;
}

export function SectionCard({
  title, subtitle, eyebrow, actions, children, className, bodyClassName, dense,
}: SectionCardProps) {
  return (
    <section className={cn("card", className)}>
      {(title || subtitle || actions || eyebrow) && (
        <header className={cn(
          "flex flex-col gap-3 border-b border-slate-100 sm:flex-row sm:items-start sm:justify-between",
          dense ? "p-4" : "p-4 sm:p-5 lg:p-6",
        )}>
          <div className="min-w-0">
            {eyebrow && <p className="eyebrow mb-1">{eyebrow}</p>}
            {title && <h2 className="section-heading">{title}</h2>}
            {subtitle && <p className="section-caption mt-1">{subtitle}</p>}
          </div>
          {actions && (
            <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>
          )}
        </header>
      )}
      <div className={cn(dense ? "p-4" : "p-4 sm:p-5 lg:p-6", bodyClassName)}>
        {children}
      </div>
    </section>
  );
}
